import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { queryKeyMap } from '../../../../_utils/query-keys';
import { PaymentGraphModel } from '../../../_models/payment-graph';

export const usePaymentGraph = (projectId: string) => {
  return useQuery({
    queryKey: queryKeyMap.paymentGraphData(projectId),
    queryFn: async () => {
      const paymentGraph = await axiosGet(
        `/api/projects/${projectId}/payment-graph-data/`,
      );
      return PaymentGraphModel.parse(paymentGraph);
    },
  });
};
